import { render, staticRenderFns } from "./LayerAddingDialog.vue?vue&type=template&id=28d4f131&scoped=true&"
import script from "./LayerAddingDialog.vue?vue&type=script&lang=js&"
export * from "./LayerAddingDialog.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingDialog.vue?vue&type=style&index=0&id=28d4f131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4f131",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
